export default __webpack_public_path__ + "static/tour-eb61c576196fc5e84d0384132ac3f23f.jpg";